import React from "react";
import "./Layout.scss";
import { Header, Menu, Footer, Hero } from "../index";
import imageHero from "../../assets/images/hero.jpg";

const Layout = ({ children, background, color }) => {
    return (
        <div className="layout">
            <Menu background={background} color={color} />
            <div className="layout__container">
                {children}
                <Footer />
            </div>
        </div>
    )
}

export default Layout;
